import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { SplitText } from 'gsap/SplitText'
import { homeBannerPlay } from './home-banner.js'
import { headingSweep } from './heading-sweep.js'
// import { servicesPreview } from './services-preview.js'
import { statistics } from './statistics.js'
import { articlesPreview } from './articles-preview.js'
import { teamMembers } from './team-members.js'
import { plan } from './plan.js'
import { heartbeat } from './heartbeat.js'
import { valueComparison } from './value-comparison.js'
import { jargonBuster } from './jargon-buster.js'
import { statCards } from './stat-cards.js'
import { connectedCards } from './connected-cards.js'
import { beliefs } from './beliefs.js'
import { share } from './share.js'
import { logosCarousel } from './logos-carousel.js'
import { confetti } from './confetti.js'

gsap.registerPlugin(ScrollTrigger, SplitText)

export const animation = () => {
	document.fonts.ready.then(() => {
		headings(document)
		paragraph(document)
		enter(document)
		homeBannerPlay()
		headingSweep()
		// servicesPreview()
		statistics()
		beliefs()
		articlesPreview()
		teamMembers()
		plan()
		heartbeat()
		valueComparison()
		jargonBuster()
		statCards()
		connectedCards()
		share()
		logosCarousel()
		confetti()
	})
}

export const headings = scope => {

	let els = scope.querySelectorAll('[data-animation="heading"]')

	if (!els.length) return

	document.fonts.ready.then(() => {
		els.forEach(el => {

			el.style.opacity = 1

			let trigger = el,
				split = new SplitText(el, { type: 'lines, words', linesClass: 'line', wordsClass: 'word' }),
				delay = el.getAttribute('data-delay') ? el.getAttribute('data-delay') : 0

			el.removeAttribute('aria-label')

			if (el.dataset.trigger == 'parent') {
				trigger = el.parentElement
			} else if (el.dataset.trigger == 'grandparent') {
				trigger = el.parentElement.parentElement
			} else if (el.dataset.trigger == 'body') {
				trigger = document.body
			}

			gsap.fromTo(split.words, {
				y: '115%',
				opacity: 1,
				rotate: "4deg",
			}, {
				y: 0,
				opacity: 1,
				rotate: "0deg",
				stagger: 0.1,
				duration: 1.2,
				delay: delay,
				ease: 'power2.out',
				scrollTrigger: {
					trigger: trigger,
					start: 'top 85%',
					// markers: true,
				}
			})
		})
	})
}

export const paragraph = scope => {

	let sections = scope.querySelectorAll('[data-animation="paragraph"]')

	if (!sections.length) return

	sections.forEach(section => {

		let els = section.querySelectorAll('p, li, h1, h2, h3')

		els.forEach(el => {

			let trigger = section,
				split = new SplitText(el, { type: 'lines', linesClass: 'line' }),
				delay = section.getAttribute('data-delay') ? section.getAttribute('data-delay') : 0

			el.removeAttribute('aria-label')

			if (section.dataset.trigger == 'parent') {
				trigger = section.parentElement
			} else if (section.dataset.trigger == 'grandparent') {
				trigger = section.parentElement.parentElement
			} else if (section.dataset.trigger == 'body') {
				trigger = document.body
			}

			setTimeout(() => {

				section.style.opacity = 1

				split.lines.forEach(el => {
					const text = el.innerHTML
					const wrap = document.createElement('div')
					wrap.classList.add('line-inner')
					wrap.innerHTML = text
					el.innerHTML = ''
					el.appendChild(wrap)
				})

				let lines = section.querySelectorAll('.line-inner')

				if (!lines.length) return

				gsap.fromTo(lines, {
					y: '105%',
				}, {
					y: 0,
					stagger: 0.1,
					duration: 0.8,
					delay: delay,
					ease: 'power2.out',
					// Unsplit once revealed so the text reflows if the width changes (resize, scrollbar)
					onComplete: () => split.revert(),
					scrollTrigger: {
						trigger: trigger,
						start: 'top 85%',
						// markers: true,
					}
				})

			}, delay);
		})
	})
}

export const enter = scope => {

	let els = scope.querySelectorAll('[data-animation="enter"], [data-animation="fade-in"], [data-animation="image"]')

	if (!els.length) return

	els.forEach(el => {

		let trigger = el,
			delay = el.dataset.delay ? el.dataset.delay : 0

		if (el.dataset.trigger == 'parent') {
			trigger = el.parentElement
		} else if (el.dataset.trigger == 'grandparent') {
			trigger = el.parentElement.parentElement
		} else if (el.dataset.trigger == 'body') {
			trigger = document.body
		}

		ScrollTrigger.create({
			trigger: trigger,
			start: "top 85%",
			onEnter: () => {
				setTimeout(() => {
					el.setAttribute('data-animation-status', 'active')
				}, delay * 1000)
			},
			onLeaveBack: () => {
				// el.removeAttribute('data-animation-status')
			},
			// markers: true,
		})
	})
}

export default () => { }